// ============================================================================
// ENUMS
// ============================================================================
export var KnowledgeBaseCategory;
(function (KnowledgeBaseCategory) {
    KnowledgeBaseCategory["Snapshot"] = "Snapshot";
    KnowledgeBaseCategory["IdealCustomerProfile"] = "Ideal Customer Profile";
    KnowledgeBaseCategory["Content"] = "Content";
    KnowledgeBaseCategory["ToneOfVoice"] = "Tone of Voice";
    KnowledgeBaseCategory["CoreNarrativeAndPillars"] = "Core Narrative and Pillars";
    KnowledgeBaseCategory["BrandGuidelines"] = "Brand Guidelines";
    KnowledgeBaseCategory["VisualNarrative"] = "Visual Narrative";
    KnowledgeBaseCategory["PainPoints"] = "Pain Points";
    KnowledgeBaseCategory["Offers"] = "Offers";
    KnowledgeBaseCategory["Keywords"] = "Keywords";
    KnowledgeBaseCategory["MissionVisionValues"] = "Mission, Vision, and Values";
    KnowledgeBaseCategory["Objections"] = "Objections";
    KnowledgeBaseCategory["CaseStudiesAndTestimonials"] = "Case Studies and Testimonials";
    KnowledgeBaseCategory["DefaultMarketingLanguage"] = "Default Marketing Language";
    KnowledgeBaseCategory["Faqs"] = "FAQs";
    KnowledgeBaseCategory["Compliance"] = "Compliance";
})(KnowledgeBaseCategory || (KnowledgeBaseCategory = {}));
export var KnowledgeBaseLevel;
(function (KnowledgeBaseLevel) {
    KnowledgeBaseLevel["Company"] = "Company";
    KnowledgeBaseLevel["Workspace"] = "Workspace";
    KnowledgeBaseLevel["Campaign"] = "Campaign";
})(KnowledgeBaseLevel || (KnowledgeBaseLevel = {}));
// Use a const object instead of a TypeScript enum to avoid circular-import
// timing issues that cause the enum to resolve as `undefined` at runtime
// in Vite/ESM builds (observed as: Cannot read properties of undefined (reading 'USEnglish')).
export const MarketingLanguage = {
    USEnglish: 'USEnglish',
    UKEnglish: 'UKEnglish',
};
